import { AdvertErrorBoundary } from 'components/advert/advert-error-boundary.js';
import { AdvertFuse } from 'components/advert/advert-fuse.js';
import { IAdvertFuseProps } from 'components/advert/types.js';
import { InterstitialHook } from 'components/interstitial/hook/interstitial-hook.js';

export const InterstitialAdvert = (props: Omit<IAdvertFuseProps, 'origin'>) => {
  const { adDisplayTrueCB, adDisplayFalseCB } = InterstitialHook();
  return (
    <AdvertErrorBoundary adDisplayFalseCB={adDisplayFalseCB}>
      <AdvertFuse {...props} adDisplayTrueCB={adDisplayTrueCB} origin={'adv-interstitial'} />
    </AdvertErrorBoundary>
  );
};
